import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import Papa from 'papaparse'; // Ensure this is installed

function App() {
  const [sheetOptions, setSheetOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState({ name: '', id: '' });
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [availableLeads, setAvailableLeads] = useState(0);
  const [leadIDs, setLeadIDs] = useState([]);
  const [numToAssign, setNumToAssign] = useState(0);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('assign');
  const [file, setFile] = useState(null);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [bitrixFields, setBitrixFields] = useState([]);
  const [fieldMapping, setFieldMapping] = useState({});

  const SHEET_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.fields.json';
  const EMPLOYEE_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/user.get.json';
  const LEAD_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.list.json';
  const ADD_LEAD_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.add.json';
  const UPDATE_LEAD_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.update.json';

  const fetchSheetNames = async () => {
    try {
      const response = await axios.get(SHEET_URL);
      const result = response.data.result;
      if (result.UF_CRM_1727029488879) {
        const items = result.UF_CRM_1727029488879.items;
        setSheetOptions(items);
      }
    } catch (error) {
      console.error('Error fetching sheet names:', error);
    }
  };
  const passwordCheck = (callback) => {
    const password = window.prompt('Please enter the password:');
    if (password === '2024@Gulf#@2024') {
      callback();
    } else {
      alert('Wrong password!');
    }
  };
  const fetchEmployees = async () => {
    try {
      const response = await axios.get(EMPLOYEE_URL);
      const users = response.data.result;
      setEmployeeOptions(users);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };



  const fetchAvailableLeads = async (sheetId) => {
    try {
      let allLeads = [];
      let nextPage = 0;
      let totalLeads = 0;

      do {
        const response = await axios.get(`${LEAD_URL}?filter[UF_CRM_1727029488879]=${sheetId}&filter[STATUS_ID]=NEW&filter[ASSIGNED_BY_ID]=39&start=${nextPage}`);
        const leads = response.data.result;
        totalLeads = response.data.total;

        allLeads = [...allLeads, ...leads];
        nextPage += leads.length;
      } while (allLeads.length < totalLeads);

      setAvailableLeads(totalLeads);
      setLeadIDs(allLeads.map(lead => lead.ID));
    } catch (error) {
      console.error('Error fetching leads:', error);
    }
  };

  const assignLeads = async () => {
    setLoading(true);
    setProgress(0);
    const idsToAssign = leadIDs.slice(0, numToAssign);
    try {
      for (let i = 0; i < idsToAssign.length; i++) {
        const id = idsToAssign[i];
        await axios.post(UPDATE_LEAD_URL, {
          fields: {
            ASSIGNED_BY_ID: selectedEmployee,
            STATUS_ID: 'IN_PROCESS',
          },
          ID: id,
        });
        setProgress(((i + 1) / numToAssign) * 100);
      }
      alert(`${numToAssign} leads have been assigned successfully.`);
      setLoading(false);
      window.location.reload();
    } catch (error) {
      console.error('Error assigning leads:', error);
      setLoading(false);
    } finally {
   
      setProgress(0);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    // Parse CSV to get headers
    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const headers = results.meta.fields;
        setCsvHeaders(headers);
      },
    });
  };

  const fetchBitrixFields = async () => {
    try {
      const response = await axios.get(SHEET_URL);
      const fields = response.data.result;

      // Create an array of field objects with key and appropriate title
      const fieldsArray = Object.entries(fields).map(([key, value]) => ({
        key,
        title: value.listLabel || value.title, // Use listLabel if available, otherwise use title
      }));

      setBitrixFields(fieldsArray);
    } catch (error) {
      console.error('Error fetching Bitrix fields:', error);
    }
  };

  const handleFieldMappingChange = (csvHeader, bitrixField) => {
    setFieldMapping({ ...fieldMapping, [csvHeader]: bitrixField });
  };

  useEffect(() => {
    fetchSheetNames();
    fetchEmployees();
    fetchBitrixFields();
  }, []);

  const addFileNameToDropdown = async (fileName) => {
    const FIELD_GET_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.userfield.get?id=483';
    const FIELD_UPDATE_URL = 'https://gulfrealtyae.bitrix24.com/rest/9/tljb75p4msenm537/crm.lead.userfield.update';
  
    try {
      // Step 1: Fetch the current field data with the existing options
      let response = await axios.get(FIELD_GET_URL);
      let field = response.data.result;
  
      // Step 2: Check if the file name already exists in the dropdown
      const existingFile = field.LIST.find(item => item.VALUE === fileName);
  
      if (existingFile) {
        // If the filename exists, return its ID
        console.log(`Filename "${fileName}" already exists in the dropdown with ID: ${existingFile.ID}`);
        return existingFile.ID;
      }
  
      // Step 3: If the filename doesn't exist, add it to the dropdown list
      const updatedList = [
        ...field.LIST, // Existing options
        { VALUE: fileName, SORT: field.LIST.length * 100 + 100 }, // New option with updated SORT value
      ];
  
      // Step 4: Send update request with the new list
      await axios.post(FIELD_UPDATE_URL, {
        ID: '483', // The ID of the custom field
        fields: {
          LIST: updatedList,
        },
      });
  
      console.log(`Filename "${fileName}" added to the dropdown. Fetching the updated list...`);
  
      // Step 5: Fetch the list again to get the newly added file ID
      response = await axios.get(FIELD_GET_URL);
      field = response.data.result;
  
      // Step 6: Find the newly added file and return its ID
      const addedFile = field.LIST.find(item => item.VALUE === fileName);
  
      if (addedFile) {
        console.log(`Newly added filename "${fileName}" found with ID: ${addedFile.ID}`);
        return addedFile.ID;
      } else {
        throw new Error(`Failed to retrieve the ID of the newly added filename "${fileName}".`);
      }
  
    } catch (error) {
      console.error('Error adding file name to dropdown:', error);
      throw error;
    }
  };
  


  const addToPool = async () => {
    if (!file) return;

    setLoading(true);
    setProgress(0);

    const fileNamedropdown = file.name.replace('.csv', '');

    try {
      // Add the file name to the dropdown in Bitrix and get the added file ID
      const dropdownFileID = await addFileNameToDropdown(fileNamedropdown);

      // Parse CSV file
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const data = results.data;
          const totalRows = data.length;
          const createdLeadIDs = [];

          for (let i = 0; i < totalRows; i++) {
            const row = data[i];
            const fields = {
              TITLE: row[fieldMapping['TITLE']] || `Lead ${i + 1}`,
              ASSIGNED_BY_ID: 39,
              UF_CRM_1727029488879: '215', // Update this field with the sheet ID if needed
            };

            // Map PHONE and EMAIL fields
            Object.keys(fieldMapping).forEach((csvHeader) => {
              const mappedField = fieldMapping[csvHeader];

              if (mappedField) {
                if (mappedField === 'PHONE' && row[csvHeader]) {
                  fields.PHONE = [
                    {
                      VALUE: row[csvHeader],
                      VALUE_TYPE: "WORK", 
                    },
                  ];
                } else if (mappedField === 'EMAIL' && row[csvHeader]) {
                  fields.EMAIL = [
                    {
                      VALUE: row[csvHeader],
                      VALUE_TYPE: "WORK", 
                    },
                  ];
                } else {
                  fields[mappedField] = row[csvHeader];
                }
              }
            });

            // Add lead to Bitrix
            const leadResponse = await axios.post(ADD_LEAD_URL, { fields });
            const leadID = leadResponse.data.result;
            createdLeadIDs.push(leadID);

            // Update progress
            setProgress(((i + 1) / totalRows) * 100);
          }

          // Store lead IDs and update all leads with the added filename ID
          setLeadIDs(createdLeadIDs);
          await updateLeadsWithFilename(dropdownFileID, createdLeadIDs);

          
        },
      });
    } catch (error) {
      console.error('Error adding leads:', error);
      setLoading(false);
    } finally {
      
      setProgress(0);
    }
  };

  const updateLeadsWithFilename = async (filenameID, leadIDs) => {
    try {
      for (const leadID of leadIDs) {
        await axios.post(UPDATE_LEAD_URL, {
          ID: leadID,
          fields: {
            UF_CRM_1727029488879: filenameID, // Update with the new filename ID
          },
        });
      }
      alert('All leads have been added and updated successfully.');
      setLoading(false);
    } catch (error) {
      console.error('Error updating leads with filename ID:', error);
    }
  };




  return (
    <div className="App">
    <header className="App-header">
      {/* Add the logo */}
      <img
        src="https://i.postimg.cc/Y0FDQpRB/Code-Hummers-Logo-Horizontal-a75f576a-removebg-preview.png"
        alt="Company Logo"
        className="logo"
      />
        <div className="top-right-dropdown">
          <label>Mode: </label>
          <select value={mode} onChange={(e) => setMode(e.target.value)}>
            <option value="assign">Assign Leads</option>
            <option value="upload">Upload New Sheet</option>
          </select>
        </div>

        <h1>{mode === 'assign' ? 'Leads Assign Module' : 'Upload Sheet Module'}</h1>

        {mode === 'assign' ? (
          <div className="form-row">
            <div className="dropdown-item">
              <label>Select Sheet</label>
              <select
                value={selectedSheet.id}
                onChange={(e) => {
                  const selectedOption = sheetOptions.find(sheet => sheet.ID === e.target.value);
                  setSelectedSheet({ name: selectedOption.VALUE, id: selectedOption.ID });
                  fetchAvailableLeads(selectedOption.ID);
                }}
              >
                <option value="">Sheet Name</option>
                {sheetOptions.map((sheet) => (
                  <option key={sheet.ID} value={sheet.ID}>
                    {sheet.VALUE}
                  </option>
                ))}
              </select>
            </div>

            <div className="dropdown-item">
              <label>Assign to</label>
              <select
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
              >
                <option value="">Select Employee</option>
                {employeeOptions.map((employee) => (
                  <option key={employee.ID} value={employee.ID}>
                    {employee.NAME} {employee.LAST_NAME}
                  </option>
                ))}
              </select>
            </div>

            <div className="dropdown-item">
              <label>How Many</label>
              <input
                type="number"
                value={numToAssign}
                onChange={(e) => setNumToAssign(e.target.value)}
                min="1"
                max={availableLeads}
              />
            </div>
          </div>
        ) : (
          <div className="upload-container">
           
            <label>Choose File (CSV)</label>

            {/* Hidden file input */}
            <input
              type="file"
              id="file-input"
              accept=".csv"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />

            {/* Image that acts as the 'Choose File' button */}
            <label htmlFor="file-input">
              <img
                src="https://i.postimg.cc/x1QTZ5XL/pngtree-3d-yellow-upload-button-png-image-12500535-removebg-preview.png"
                alt="Choose File"
                style={{ cursor: 'pointer', width: '150px' }}
              />
            </label>
            {file && <p>Selected file: {file.name}</p>}

            <h3>Field Mapping</h3>
            {csvHeaders.map((header, index) => (
              <div key={index} className="mapping-row">
                <span>{header}</span>
                <select
                  value={fieldMapping[header] || ''}
                  onChange={(e) => handleFieldMappingChange(header, e.target.value)}
                >
                  <option value="">Select Bitrix Field</option>
                  {bitrixFields.map((field) => (
                    <option key={field.key} value={field.key}>
                      {field.title}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            {/* <div className="dropdown-item">
              <label>Select Employee</label>
              <select
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
              >
                <option value="">Select Employee</option>
                {employeeOptions.map((employee) => (
                  <option key={employee.ID} value={employee.ID}>
                    {employee.NAME} {employee.LAST_NAME}
                  </option>
                ))}
              </select>
            </div> */}

            {loading && (
              <div className="progress-bar">
                <div className="progress" style={{ width: `${progress}%` }}></div>
              </div>
            )}


<button onClick={() => passwordCheck(addToPool)} disabled={loading || !file}>
              {loading ? 'Adding to Pool...' : 'Add to Pool'}
            </button>


          </div>

        )}

        {selectedSheet.id && mode === 'assign' && (
          <div>
            <h3>You selected sheet: {selectedSheet.name} Sheet</h3>
          </div>
        )}

        {availableLeads >= 0 && mode === 'assign' && (
          <div>
            <h3>Available Leads: {availableLeads}</h3>
          </div>
        )}

        {loading && (
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
        )}

    
        {mode === 'assign' && (
             <button onClick={() => passwordCheck(assignLeads)} disabled={loading || numToAssign <= 0 || !selectedEmployee}>
            {loading ? 'Assigning...' : 'Assign Leads'}
          </button>
        )}
        <h5 style={{ fontSize : '1rem' , paddingTop : '5rem'}}>
        2024@CopyRight Code Hummers IT Services All Rights Reserved ^TM
        </h5>
      
      </header>
      
    </div>
  );
}

export default App;
